import { kvRows } from "./PDFKeyValue";

/**
 * Sección de información a DOS COLUMNAS EQUILIBRADAS (50/50), sin bordes ni
 * fondos (las secciones se separan con divisorias, no con cajas). Bloques 2 y 3
 * del sistema BIWO.

 * @param {object} params
 * @param {Array<{label,value,strong?}>} params.left  filas columna izquierda
 * @param {Array<{label,value,strong?}>} params.right filas columna derecha
 * @param {string|number} params.labelWidthLeft
 * @param {string|number} params.labelWidthRight
 * @returns nodo pdfMake (columns)
 */
export const PDFCompanyInfoV2 = ({
  left = [],
  right = [],
  labelWidthLeft = "30%",
  labelWidthRight = "40%",
  fontSize,
} = {}) => ({
  margin: [0, 2, 0, 2],
  columns: [
    {
      width: "50%",
      stack: kvRows(left, { labelWidth: labelWidthLeft, fontSize }),
    },
    {
      width: "50%",
      stack: kvRows(right, { labelWidth: labelWidthRight, fontSize }),
    },
  ],
  columnGap: 24,
});

export default PDFCompanyInfoV2;